var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('collapse',{attrs:{"collapsable":false,"title":_vm.$t('_.email_history')}},[_c('tabigation',{attrs:{"routes":_vm.defaultRoutes}}),_vm._v(" "),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }